import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../translations';
import withRouter from '../../hooks/withRouter';
import { toggleVideo, handleRepeatActivity } from 'store/actions/activity';
import videoIcon from 'assets/svg/video-icon.svg';
import repeatIcon from 'assets/svg/repeat.svg';
import style from './Toolbar.module.scss';

const hasActivityVideo = (currentRoundIndex, activities, isLoading) => {
  if (currentRoundIndex < 0 || !activities || !activities.length) return null;
  if (isLoading && currentRoundIndex >= 0) return null;
  const currentRound = activities[currentRoundIndex];
  return currentRound && currentRound.data.tutorial;
};

export const Toolbar = ({
  currentRoundIndex,
  activities,
  isLoading,
  toggleVideo,
  handleRepeatActivity,
  contentScaling,
  overlayActive
}) => {
  const hasVideo = hasActivityVideo(currentRoundIndex, activities, isLoading);

  return (
    <div className={style.toolbar}>
      {hasVideo && (
        <button
          id="tutorial-button"
          className={[
            'gss-button',
            style.videoPlayBtn,
            style[`videoPlayBtn${contentScaling}`]
          ].join(' ')}
          onClick={() => {
            toggleVideo(true);
          }}
          aria-label={t('Tutorial')}
        >
          <img src={videoIcon} alt={''} />
        </button>
      )}
      {!isLoading && (
        <button
          id="repeat-button"
          className={['gss-button', style.repeatBtn, style[`repeatBtn${contentScaling}`]].join(' ')}
          onClick={() => handleRepeatActivity()}
          aria-label={t('RepeatActivity')}
          tabIndex={overlayActive ? -1 : 0}
          aria-hidden={overlayActive ? 'true' : undefined}
        >
          <img src={repeatIcon} alt={''} />
        </button>
      )}
    </div>
  );
};

Toolbar.propTypes = {
  currentRoundIndex: PropTypes.number,
  activities: PropTypes.array,
  isLoading: PropTypes.bool,
  toggleVideo: PropTypes.func,
  handleRepeatActivity: PropTypes.func,
  router: PropTypes.object,
  contentScaling: PropTypes.number,
  overlayActive: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoading: state.ui.loading,
  currentRoundIndex: state.activity.currentRoundIndex,
  activities: state.activity.activities
});

const ConnectedToolbar = connect(mapStateToProps, {
  toggleVideo,
  handleRepeatActivity
})(withRouter(Toolbar));
export default ConnectedToolbar;
